import React, {Dispatch, useEffect, useState} from 'react';
import Map from "../Map";
import Autocomplete from "react-google-autocomplete";
import {Marker} from "../App";
import PlaceResult = google.maps.places.PlaceResult;
import './SelectLocationStep.scss'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'

type Props = {
    marker: Marker|undefined,
    setMarker: Dispatch<Marker|undefined>
    onPlaceSelected: (place: PlaceResult) => void,
    setStep: Dispatch<string>
}
function SelectLocationStep({marker, setMarker, onPlaceSelected, setStep}: Props) {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const resetLocation = (e: React.MouseEvent) => {
        e.preventDefault();
        setMarker(undefined);
    }

    const nextStepHandler = (e: React.MouseEvent) => {
        e.preventDefault();
        if (!marker?.rainWater) {
            return;
        }

        setStep('dataFrom');
    }

    return <div className={'SelectLocationStep'}>
        <div className="container">
            <div className="row">
                <div className="col-md-5 flex-center-row">
                    <div className="autocomplete-container">
                        <div className={'description'}>
                            <h2>KROK I</h2>
                            <h3>TWOJA MIEJSCOWOŚĆ NA MAPIE ŚREDNICH ROCZNYCH OPADÓW:</h3>
                            Zacznijmy od określenia przybliżonego położenia Twojej działki. Po wpisaniu nazwy miejscowości w oknie poniżej, nasza mapa automatycznie wskaże Ci w jakiej strefie średnich opadów rocznych się znajdujesz. Pozwoli to przekazać do kalkulatora podstawowe informacje o potencjale zbierania deszczówki w Twoim regionie.
                        </div>
                        <div className="autocomplete">
                            <div
                                className={"form-row thwcfe-required validate-required thwcfe-input-field-wrapper validate-required"}
                                id={"autocomplete"}
                            >
                                <label htmlFor="autocomplete"><span>WPISZ NAZWĘ MIEJSCOWOŚCI:</span><a className='tooltip-icon' data-tooltip-id="location-tooltip" data-tooltip-content="Zacznij wprowadzać nazwę Twojej miejscowości, a następnie wybierz z listy"><span>?</span></a></label>
                                {!marker && <span className={"woocommerce-input-wrapper"}>
                        <Autocomplete
                            apiKey={"AIzaSyDww2OKZCu-IaWKh1W4EOAZjS3peE0zMnM"}
                            onPlaceSelected={onPlaceSelected}
                            options={{componentRestrictions: { country: "pl" }}}
                            id={"location"}
                            className={"input-text thwcfe-input-field"}
                            placeholder={"Podaj miejscowość"}
                        />
                        </span>}
                                    {marker && <span className={"woocommerce-input-wrapper"}>
                            {marker && marker.rainWater === null &&
                                <div>
                                    <b>Brak danych o opadach dla miejscowości {marker.name}.</b>
                                </div>
                            }
                                        {marker && marker.rainWater && <div>
                                            <b>{marker.name}</b><br/>
                                            Ilość opadów: <b>{marker.rainWaterDescription}mm</b>
                                        </div>}
                        </span>}
                            </div>

                        </div>
                        <div className={'bottom-buttons'}>
                            <div>
                                <a className={marker ? "yellow-button" : "yellow-button disable-button"} onClick={resetLocation}>Zmień miejscowość</a>
                            </div>

                            <div>
                                <a className={marker && marker.rainWater ? "yellow-button" : "yellow-button disable-button"} onClick={nextStepHandler}>Dalej</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-7">
                    <Map
                        marker={marker}
                        setMarker={setMarker}
                    />
                </div>
                <Tooltip id="location-tooltip" />
            </div>
        </div>
    </div>
}

export default SelectLocationStep;